import Cookie from "js-cookie";
import noticeError from "./notice-error";
import { requestHelper } from "./request-helper";
;
export async function fetchMediaData(paginationCursor, countPerPage, categoryId) {
    const url = new URL(window.location.href);
    const xSiteOrigin = url.searchParams.get("x-site-origin") ||
        Cookie.get("x-site-origin");
    const context = window?.asos && window.asos.webContext;
    const webContext = {
        language: context.getBrowseLanguage(),
        storeId: context.getStoreId(),
    };
    const sortType = "recent";
    const mediaType = "image";
    const includeOutOfStock = false;
    try {
        const response = await requestHelper.get({
            url: `/api/marketing/user-generated-content/v1/categories/${categoryId}/media/`,
            params: {
                store: webContext.storeId,
                lang: webContext.language,
                cursor: paginationCursor,
                limit: countPerPage,
                sortType: sortType,
                mediaType: mediaType,
                includeOutOfStock: includeOutOfStock,
                "x-site-origin": xSiteOrigin,
            }
        });
        if (response.status !== 200) {
            throw new Error("Failed to fetch UGC data");
        }
        return await response.data;
    }
    catch (error) {
        noticeError(error);
    }
}
